import mongoose from 'mongoose';
import schema, { ICityGeoCodeCacheDocument } from '../schemas/city-geocode-cache';

const CityGeoCodeCache = (mongoose.models.CityGeoCodeCache ||
  mongoose.model<ICityGeoCodeCacheDocument>('CityGeoCodeCache', schema)) as mongoose.Model<
  ICityGeoCodeCacheDocument
>;

export default CityGeoCodeCache;
